<mibi-box-layout>

    <article class="mibi-datenschutzerklaerung">

        <h3 class="mibi-datenschutzerklaerung-item-header">
            1. Wer ist für die Datenverarbeitung verantwortlich, und an wen kann ich mich wenden?
        </h3>
        <div class="mibi-datenschutzerklaerung-item">
            <p>
                Das Bundesinstitut für Risikobewertung ist für die Verarbeitung Ihrer Daten im Sinne des Art. 4 Nr. 7
                DS-GVO verantwortlich. Nachfolgend finden Sie unsere Kontaktdaten:
            </p>
            <table>
                <tbody>
                    <tr>Bundesinstitut für Risikobewertung (BfR)</tr>
                    <tr>Max-Dohrn-Str. 8-10</tr>
                    <tr>10589 Berlin</tr>
                    <tr>Tel.: 030-18412-0</tr>
                    <tr>E-Mail: <a href="mailto:poststelle@bfr.bund.de">poststelle&#64;bfr.bund.de</a></tr>
                    <tr><a href="https://www.bfr.bund.de" target="_blank" rel="noopener">www.bfr.bund.de</a></tr>
                </tbody>
            </table>
            <br>
            <p>
                Bei Fragen zur Verarbeitung Ihrer Daten und zum Datenschutz wenden Sie sich bitte an 
                <span *ngIf="dataProtectionOfficerIdCard.gender === 'male'">
                    unseren behördlichen Datenschutzbeauftragten:
                </span>
                <span *ngIf="dataProtectionOfficerIdCard.gender === 'female'">
                    unsere behördliche Datenschutzbeauftragte:
                </span>
            </p>
            <table>
                <tbody>
                    <tr>{{dataProtectionOfficerIdCard.prefix}} {{dataProtectionOfficerIdCard.name}}</tr>
                    <tr *ngFor="let info of dataProtectionOfficerIdCard.infos">{{info}}</tr>
                    <tr>E-Mail: <a [href]="'mailto:' + dataProtectionOfficerIdCard.email">{{dataProtectionOfficerIdCard.email}}</a></tr>
                </tbody>
            </table>
        </div>

        <h3 class="mibi-datenschutzerklaerung-item-header">
            2. Auf welcher Rechtsgrundlage verarbeiten wir Ihre personenbezogenen Daten?
        </h3>
        <div class="mibi-datenschutzerklaerung-item">
            <p>Die Verarbeitung personenbezogener Daten im BfR erfolgt in Übereinstimmung
                mit der <a
                    [href]="dsGvoLink"
                    target="_blank" rel="noopener">Europäischen
                    Datenschutz-Grundverordnung (DS-GVO)</a>, dem Telemediengesetz (TMG) und dem
                <a href="https://www.gesetze-im-internet.de/bdsg_2018/" target="_blank"
                    rel="noopener">Bundesdatenschutzgesetz (BDSG)</a>
            </p>
            <p>
                Soweit das BfR für Verarbeitungsvorgänge personenbezogener Daten eine Einwilligung der betroffenen
                Person
                einholt, dient Art. 6 Abs. 1 lit. a DS-GVO als Rechtsgrundlage. Eine erteilte Einwilligung kann
                jederzeit
                mit
                Wirkung für die Zukunft widerrufen werden. Dies gilt auch für den Widerruf von Einwilligungserklärungen,
                die
                vor der Geltung der DS-GVO, also vor dem 25. Mai 2018, uns gegenüber erteilt worden sind.
            </p>
            <p>
                Bei der Verarbeitung von personenbezogenen Daten, die zur Erfüllung eines Vertrages, dessen
                Vertragspartei
                die
                betroffene Person ist, erforderlich ist, dient im Einzelfall Art. 6 Abs. 1 lit. b DS-GVO als
                Rechtsgrundlage.
                Dies gilt auch für Verarbeitungsvorgänge, die zur Durchführung vorvertraglicher Maßnahmen erforderlich
                sind.
            </p>
            <p>
                Soweit eine Verarbeitung personenbezogener Daten im Einzelfall zur Erfüllung einer rechtlichen
                Verpflichtung
                erforderlich sein sollte, dient zudem Art. 6 Abs. 1 lit. c DS-GVO in Verbindung mit der entsprechenden
                Rechtsvorschrift, aus der sich die rechtliche Verpflichtung ergibt, als Rechtsgrundlage.
            </p>
            <p>
                In dem seltenen Fall, dass lebenswichtige Interessen der betroffenen Person oder einer anderen
                natürlichen
                Person eine Verarbeitung personenbezogener Daten erforderlich machen, dient Art. 6 Abs. 1 lit. d DS-GVO
                als
                Rechtsgrundlage.
            </p>
            <p>
                Das BfR verarbeitet bei der Wahrnehmung der ihm obliegenden im öffentlichen Interesse liegenden Aufgaben
                personenbezogene Daten. Zu den öffentlichen Aufgaben des BfR gehören insbesondere die ihm nach dem
                BfR-Gesetz
                (BfRG) übertragenen Aufgaben und Tätigkeiten. Rechtsgrundlage der Verarbeitung ist hier Art. 6 Abs. 1
                lit.
                e
                der DS-GVO in Verbindung mit den entsprechenden Vorschriften des BfRG, insbesondere § 2 BfRG.
            </p>
            <p>
                Soweit erforderlich, verarbeiten wir Ihre Daten darüber hinaus zur Wahrung berechtigter Interessen von
                uns
                oder
                Dritten. Beispiele können sein: Die Geltendmachung rechtlicher Ansprüche und Verteidigung bei
                rechtlichen
                Streitigkeiten, die Gewährleistung der IT-Sicherheit und des IT-Betriebs des BfR, die
                Öffentlichkeitsarbeit
                des
                BfR oder auch die Verhinderung von Straftaten (u.a.). In solchen Fällen dient als Rechtsgrundlage Art. 6
                Abs. 1
                lit. f DS-GVO.
            </p>
        </div>


        <h3 class="mibi-datenschutzerklaerung-item-header">
            3. Welche personenbezogenen Daten werden im Zusammenhang mit dem Besuch unserer Internetseite verarbeitet?
        </h3>
        <h4 class="mibi-datenschutzerklaerung-item-subheader">
            3.1 Datenerfassung
        </h4>
        <div class="mibi-datenschutzerklaerung-item">
            <p>
                Bei jedem Zugriff eines Nutzers auf unser Internet-Angebot und bei jedem Abruf einer Datei werden Daten
                über
                diesen Vorgang vorübergehend in einer Logdatei des Webservers verarbeitet.

                Im Einzelnen werden über jeden Zugriff/Abruf folgende Daten gespeichert:
            </p>
            <ul class="mibi-datenschutzerklaerung-list">
                <li>Browsertyp und -version</li>
                <li>verwendetes Betriebssystem</li>
                <li>Website, von der aus Sie uns besuchen (Referrer URL)</li>
                <li>Website, die Sie besuchen</li>
                <li>Datum und Uhrzeit Ihres Zugriffs</li>
                <li>Ihre Internet Protokoll (IP)-Adresse in anonymisierter Form</li>
            </ul>
            <p>
                Rechtsgrundlage für die vorübergehende Speicherung der Daten ist Art. 6 Abs. 1 lit. e bzw. f DS-GVO.
                Eine
                Zusammenführung mit anderen personenbezogenen Daten des Nutzers findet nicht statt.
            </p>
            <p>
                Bei der Nutzung dieser Informationen zieht das BfR keine Rückschlüsse auf die betroffene Person. Diese
                Informationen werden vielmehr benötigt, um
            </p>
            <ul class="mibi-datenschutzerklaerung-list">
                <li>die Inhalte unserer Webseite korrekt auszuliefern,</li>
                <li>die Inhalte unserer Webseite zu optimieren,</li>
                <li>die Funktionsfähigkeit unserer IT-Systeme und der Technik unserer Webseite zu gewährleisten</li>
            </ul>
            <p>
                Die Löschung der Logfiles erfolgt nach 14 Tagen.
            </p>
        </div>

        <h4 class="mibi-datenschutzerklaerung-item-subheader">
            3.2 Welche personenbezogenen Daten werden im Rahmen der Registrierung verarbeitet?
        </h4>
        <div class="mibi-datenschutzerklaerung-item">
            <p>
                Siehe hierzu unsere <a [routerLink]="[userLinks.privacyPolicy]">Datenschutzhinweise</a> für das
                MiBi-Portal
            </p>
        </div>

        <h4 class="mibi-datenschutzerklaerung-item-subheader">
            3.3 Kontaktaufnahme per E-Mail
        </h4>
        <div class="mibi-datenschutzerklaerung-item">
            <p>
                Die Kontaktaufnahme zum MiBi-Portal-Team kann per E-Mail über die Funktions-E-Mail-Adresse <a
                    href="mailto:mibi-portal@bfr.bund.de">mibi-portal&#64;bfr.bund.de</a>
                erfolgen.

                Soweit Sie diesen Kontaktweg verwenden, werden die von Ihnen übermittelten Daten (z.B.: Name, Vorname,
                Anschrift
                o.ä.), zumindest jedoch die E-Mail-Adresse, sowie die in der E-Mail enthaltenen Informationen (inklusive
                ggf. von
                Ihnen übermittelter personenbezogener Daten) zum Zwecke der Kontaktaufnahme und Bearbeitung Ihres
                Anliegens
                verarbeitet. Wir weisen Sie darauf hin, dass die Verarbeitung der Daten auf Grundlage von Artikel 6
                Absatz
                1 lit. e
                DSGVO in Verbindung mit §3 BDSG erfolgt. Eine Verarbeitung der von Ihnen übermittelten personenbezogenen
                Daten ist
                zum Zweck der Bearbeitung Ihres Anliegens erforderlich.
            </p>
        </div>

        <h3 class="mibi-datenschutzerklaerung-item-header">
            4. Werden Daten in ein Drittland oder an eine internationale Organisation übermittelt?
        </h3>
        <div class="mibi-datenschutzerklaerung-item">
            <p>
                Eine Datenübermittlung in Länder außerhalb der EU bzw. des EWR (sog. Drittstaaten) findet nur statt,
                soweit
                dies vertraglich erforderlich oder gesetzlich vorgeschrieben ist bzw. im Rahmen einer
                Auftragsdatenverarbeitung. Werden Auftragsdatenverarbeiter in einem Drittstaat eingesetzt, werden diese
                vertraglich zur Einhaltung der datenschutzrechtlichen Vorgaben der EU verpflichtet.
            </p>
        </div>



        <h3 class="mibi-datenschutzerklaerung-item-header">
            5. Welche Datenschutzrechte habe ich?
        </h3>
        <div class="mibi-datenschutzerklaerung-item">
            <p>
                Sie haben gegenüber dem BfR folgende Rechte hinsichtlich der Sie betreffenden personenbezogenen Daten:
            </p>
            <ul class="mibi-datenschutzerklaerung-list">
                <li>das Recht auf Auskunft nach Art. 15 DS-GVO,</li>
                <li>das Recht auf Berichtigung nach Art. 16 DS-GVO,</li>
                <li>das Recht auf Löschung nach Art. 17 DS-GVO,</li>
                <li>das Recht auf Einschränkung der Verarbeitung nach Art. 18 DS-GVO,</li>
                <li>das Recht auf Widerspruch aus Art. 21 DS-GVO</li>
                <li>sowie das Recht auf Datenübertragbarkeit aus Art. 20 DS-GVO.</li>
                <li>Beim Auskunftsrecht und beim Löschungsrecht gelten die Einschränkungen nach §§ 34 und 35 BDSG.</li>
            </ul>
            <p>
                Eine erteilte Einwilligung in die Verarbeitung personenbezogener Daten können Sie jederzeit uns
                gegenüber
                mit
                Wirkung für die Zukunft widerrufen. Dies gilt auch für den Widerruf von Einwilligungserklärungen, die
                vor
                der
                Geltung der Datenschutz-Grundverordnung, also vor dem 25. Mai 2018, uns gegenüber erteilt worden sind.
            </p>
            <p>
                Die vorgenannten Rechte können Sie unter poststelle&#64;bfr.bund.de oder postalisch über die zu Beginn
                dieser
                Datenschutzerklärung genannte Postadresse des BfR geltend machen.
            </p>
            <p>
                Ihnen steht zudem ein Beschwerderecht bei der datenschutzrechtlichen Aufsichtsbehörde,
                (Bundesbeauftragte
                für
                den Datenschutz und die Informationsfreiheit) zu, vgl. Art. 77 DS-GVO i.V.m. § 19 BDSG.
            </p>
            <p>
                Sie können sich mit Fragen und Beschwerden auch an die/den Beauftragte/n für den Datenschutz im BfR
                (<a href="mailto:dsb@bfr.bund.de">dsb&#64;bfr.bund.de</a>) wenden.
            </p>
        </div>


        <h3 class="mibi-datenschutzerklaerung-item-header">
            6. Änderung der Datenschutzerklärung
        </h3>
        <div class="mibi-datenschutzerklaerung-item">
            <p>
                Das BfR behält sich vor, die Datenschutzerklärung anzupassen, damit sie stets den aktuellen rechtlichen
                Anforderungen entspricht. Wir empfehlen Ihnen, unsere Datenschutzerklärung regelmäßig zu lesen, um über
                den
                Schutz der von uns erfassten personenbezogenen Daten auf dem neusten Stand zu bleiben.
            </p>
        </div>

        <footer class="mibi-datenschutzerklaerung-footer">
            <span class="mat-small">Stand:
                <time>24.06.2025</time>
            </span>
        </footer>
    </article>
</mibi-box-layout>